import { Descriptions, Divider, Typography, theme } from "antd";
import React from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { selectCurrentBusiness } from "../../../businessesSlice";
import { getFullDate } from "../../../utils/getFullDate";
import { getFullAddress } from "../../../utils/getFullAddress";
import { MissingTag } from "../BusinessDetailsModal";

const { Text } = Typography;

const BusinessGeneral: React.FC = () => {
  const { token } = theme.useToken();
  const business = useAppSelector(selectCurrentBusiness);

  if (!business) {
    return null;
  }

  return (
    <div style={{ padding: token.padding }}>
      <Descriptions
        title="Business Information"
        column={2}
        labelStyle={{ fontWeight: "bold" }}
      >
        <Descriptions.Item label="Business ID">
          {business._id}
        </Descriptions.Item>
        <Descriptions.Item label="Business Name">
          {business.businessName}
        </Descriptions.Item>
        <Descriptions.Item label="Registration Number">
          {business.businessRegistrationNumber}
        </Descriptions.Item>
        <Descriptions.Item label="Email">
          {business.rootUser?.email}
        </Descriptions.Item>
        <Descriptions.Item label="VAT Number">
          {business.vatNumber || <Text type="secondary">Not provided</Text>}
        </Descriptions.Item>
        <Descriptions.Item label="Fiscal Code (TIN)">
          {business.tinNumber || <Text type="secondary">Not provided</Text>}
        </Descriptions.Item>
        <Descriptions.Item label="Name">
          {business.rootUser?.name}
        </Descriptions.Item>
      </Descriptions>

      <Divider />

      <Descriptions
        title="Bank Account Details"
        column={2}
        labelStyle={{ fontWeight: "bold" }}
      >
        <Descriptions.Item label="IBAN">
          {business.bankAccountIban || (
            <Text type="secondary">Not provided</Text>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Account Number">
          {business.bankAccountNumber || (
            <Text type="secondary">Not provided</Text>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Bank Name">
          {business.bankName || <Text type="secondary">Not provided</Text>}
        </Descriptions.Item>
        <Descriptions.Item label="Branch Number">
          {business.bankBranchNumber || (
            <Text type="secondary">Not provided</Text>
          )}
        </Descriptions.Item>
      </Descriptions>

      <Divider />

      <Descriptions
        title="Additional Information"
        column={2}
        labelStyle={{ fontWeight: "bold" }}
      >
        <Descriptions.Item label="Industry">
          {business.industry || <Text type="secondary">Not provided</Text>}
        </Descriptions.Item>
        <Descriptions.Item label="MCC">
          {business.mcc || <Text type="secondary">Not provided</Text>}
        </Descriptions.Item>
        <Descriptions.Item label="Website">
          {business.website ? (
            <a
              href={business.website}
              target="_blank"
              rel="noopener noreferrer"
            >
              {business.website}
            </a>
          ) : (
            <Text type="secondary">Not provided</Text>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Phone">
          {business.phone || <Text type="secondary">Not provided</Text>}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default BusinessGeneral;
